<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    />
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="table.title"
    />
  </div>
</template>
<script>
import * as member from "@/api/product/member.js";
import * as userGroup from "@/api/product/user-group.js";
import * as dept from "@/api/dept/dept.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      formData: {},
      formDesc: {
        coding: {
          label: "会员编号(导游编号)",
          type: "text",
          disabled: true
        },
        openid: {
          label: "微信Id",
          type: "text",
          disabled: true
        },
        is_share: {
          label: "分销人员",
          type: "text",
          options: [
            {
              text: "已停用",
              value: -2
            },
            {
              text: "待审核",
              value: -1
            },
            {
              text: "不是",
              value: 0
            },
            {
              text: "是",
              value: 1
            }
          ],
          disabled: true
        },
        name: {
          label: "用户名称",
          type: "text",
          disabled: true
        },
        mobile: {
          label: "手机号",
          type: "text",
          disabled: true
        },
        idcard: {
          label: "身份号",
          type: "text",
          disabled: true
        },
        status: {
          label: "审核",
          type: "radio",
          required: true,
          options: [
            {
              text: "通过申请",
              value: 1
            },
            {
              text: "驳回申请",
              value: 2
            }
          ]
        },
        group_id: {
          label: "所属分组",
          type: "select",
          required: true,
          options: userGroup.deleteUserGroupAll.r()
        },
        dept_id: {
          label: "所属部门",
          type: "select",
          show: "tag",
          prop: {
            text: "label",
            value: "id"
          },
          options: dept.getDeptTree.r(),
          hide: true
        }
      },
      rules: {},
      dialogFormVisible: false,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "会员",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "name",
            label: "用户昵称",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            hide: true
          },
          {
            prop: "mobile",
            label: "手机号",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            hide: true
          },
          {
            prop: "idcard",
            label: "身份证号",
            type: "input",
            // 1普通用户 2会员用户 3分销商用户
            hide: true
          },
          {
            prop: "balance",
            label: "余额",
            hide: true
          },
          {
            prop: "status",
            label: "用户状态",
            type: "input",
            show: "tag",
            // 1普通会员 2正式会员 3付费会员
            tagtype: [
              {
                text: "限制使用",
                value: -1
              },
              {
                text: "正常",
                value: 1
              },
              {
                text: "未提交注册信息",
                value: 2
              },
              {
                text: "待审核注册信息",
                value: 3
              },
              {
                text: "审核成功",
                value: 4
              },
              {
                text: "审核失败",
                value: 5
              }
            ],
            hide: true
          }
        ],
        btnList: [
          {
            name: "审核",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.formData = row;
              delete this.formData.status;
              delete this.formData.group_id;
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    handleSubmit(form) {
      let post = {
        user_id: form.user_id,
        status: form.status,
        group_id: form.group_id
      };
      member.editMember.r(form).then(res => {
        this.chushihua("审核成功");
      });
    },
    chushihua(text) {
      if (text) this.$message.success(text);
      this.formData = {};
      this.dialogFormVisible = false;
      this.getlist();
    },
    handleSuccess() {},
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          member.deleteMember.r({ member_id: form.member_id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      param["status"] = 3;
      member.getMemberList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
